<!-- Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. -->

<div class="multi-file-select-wrapper">
  <div
    class="fileinput-container"
    [ngClass]="{
      'file-drag-active': fileDragOver,
      'file-drag-inactive': !fileDragOver,
      'fileinput-disabled': disabled,
    }"
    (dragover)="fileDragStart($event)"
    (drop)="fileDragDrop($event)">
    <div class="file-drag-overlay" (dragleave)="fileDragEnd($event)">
      <div class="inner"><span>&nbsp;</span></div>
    </div>
    <div class="fileinput">
      @if (!multiple) {
        <div
          class="form-control"
          [ngClass]="{
            'is-invalid': mode == 'single' && fileFormatNotSupported,
          }">
          <span
            ngModel
            ngDefaultControl
            class="fileinput-filename"
            [ngClass]="{ 'placeholder-text': !(input.uploadFiles.length > 0) }"
            [ngbTooltip]="fileInputText"
            placement="top"
            [autoClose]="true"
            triggers="manual"
            #t="ngbTooltip"
            (click)="checkTrucation($event, t)"
            tooltipClass="filename-tooltip"
            >{{ fileInputText }}
            @if (input.uploadFiles.length > 0) {
              <span
                class="delete-single xgl-subtract_circle"
                (click)="delete($event, 0)"></span>
            }
          </span>
        </div>
      }
      @if (multiple) {
        <div class="form-control" (click)="uploadFilesInput.click()">
          <span class="fileinput-filename placeholder-text">{{
            fileInputText
          }}</span>
        </div>
      }
      <button
        type="button"
        class="browse-btn xrx-btn btn-secondary"
        (click)="uploadFilesInput.click(); $event.preventDefault()"
        xdaTranslate>
        SDE_BROWSE
      </button>
    </div>
  </div>
  <!-- input -->
  <input
    class="d-none"
    type="file"
    (change)="handleUploadFilesInput($event.target.files)"
    #uploadFilesInput
    ngModel
    [multiple]="multiple"
    [accept]="fileTypesAccepted"
    [attr.name]="name"
    onclick="this.value = ''" />
  @if (mode !== 'single' && !requiredField) {
    <div class="info-wrapper">
      @if (fileTypes) {
        <div
          class="info"
          [xdaTranslate]="'SDE_SUPPORTED_FILE_FORMATS1'"
          [formatValues]="fileTypes"></div>
      }
    </div>
  }
  <!-- file list -->
  @if (multiple) {
    <ul
      class="file-list-wrapper list-group"
      [ngClass]="{ 'mb-0': input.uploadFiles.length < 1 }">
      @for (
        file of input.uploadFiles;
        track file;
        let i = $index;
        let first = $first;
        let last = $last
      ) {
        <li
          class="file list-group-item list-group-item-action d-flex align-items-center justify-content-between"
          [ngClass]="{
            first: first,
            last: last,
            'is-invalid':
              !validateFileNames(file) ||
              (!validateSpecialCharacters(file) &&
                input.uploadFiles.length > 1),
          }">
          @if (mode == 'merge') {
            <span
              class="name"
              [ngbTooltip]="file.name"
              placement="top"
              [autoClose]="true"
              triggers="manual"
              #t="ngbTooltip"
              (click)="checkTrucation($event, t)"
              >{{ i + 1 }}. {{ file.name }}</span
            >
          }
          @if (mode != 'merge') {
            <span
              class="name"
              [ngbTooltip]="file.name"
              placement="top"
              [autoClose]="true"
              triggers="manual"
              #t="ngbTooltip"
              (click)="checkTrucation($event, t)"
              >{{ file.name }}</span
            >
          }
          <div class="icons d-flex align-items-center">
            @if (mode == 'merge' && !last) {
              <span
                class="down file-list-icon"
                (click)="reorder(i, 'down')"></span>
            }
            @if (mode == 'merge' && !first) {
              <span class="up file-list-icon" (click)="reorder(i, 'up')"></span>
            }
            <span
              class="delete file-list-icon"
              (click)="delete($event, i)"></span>
          </div>
        </li>
      }
    </ul>
  }
  <div>
    @if (fileFormatNotSupported) {
      <div class="fileinput-error">
        <span class="text-danger" [xdaTranslate]="'SDE_FILE_FORMAT_NOT'"></span>
      </div>
    }
    @if (specialCharactersInFileName) {
      <div class="fileinput-error">
        <span
          class="text-danger"
          [xdaTranslate]="'SDE_CHARACTERS_CANNOT_BE'"
          [formatValues]="'\&quot;?;&lt;&gt;|:\'*%^&amp;#+`\\\/'"></span>
      </div>
    }
    @if (minFilesExceeded) {
      <div class="fileinput-error">
        <span
          class="text-danger"
          [xdaTranslate]="'SDE_CONCATENATE_REQUIRES_LEAST'"></span>
      </div>
    }
    @if (!isValid && requiredField) {
      <div class="fileinput-error">
        <span class="text-danger" [xdaTranslate]="'SDE_REQUIRED_FIELD1'"></span>
      </div>
    }
    @if (!isValid && numberFileRequired) {
      <div class="fileinput-error">
        <span
          class="text-danger"
          [xdaTranslate]="'SDE_INSERT_REQUIRES_2'"></span>
      </div>
    }
    @if (mode !== 'single') {
      <div class="info-wrapper">
        @if (fileTypes && requiredField) {
          <div
            class="info"
            [xdaTranslate]="'SDE_SUPPORTED_FILE_FORMATS1'"
            [formatValues]="fileTypes"></div>
        }
        @if (maxFiles !== minFiles) {
          <span
            class="info"
            [xdaTranslate]="'SDE_SELECT_UP_FMTSTR1'"
            [formatValues]="maxFiles"></span>
        }
        @if (maxFiles === minFiles) {
          <span
            class="info"
            [xdaTranslate]="'SDE_SELECT_FMTSTR_FILES'"
            [formatValues]="maxFiles"></span>
        }
      </div>
    }
  </div>
</div>
